// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.proyectsToChange-container {
    width: 100%;
    margin: 0;
}

.proyectsToChange-container > div {
    background-color: #0e0f15;
    border: 3px solid #f09502;
}

.proyectsToChange-container .noProyectsToChange {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}

.proyectsToChange-container img {
    max-width: 30%;
    height: auto;
}

.proyectsToChange-container .valuesProyectToActivate {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}

.proyectsToChange-container .valuesProyectToActivate > div {
    padding-left: 15px;
}

.proyectsToChange-container .resaltar {
    font-weight: bold;
    color: #f09502;
}

.proyectsToChange-container .accordion-header buttom {
    background-color: #0e0f15 !important;
}

.proyectsToChange-container form > div {
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
}

.proyectsToChange-container form label {
    width: 100%;
}

.proyectsToChange-container form input {
    display: inline-block;
    width: 70%;
    margin-right: 2%;
}

.proyectsToChange-container form button {
    display: inline-block;
    width: 27%;
}

.errorInput {
    background-color: rgb(255, 196, 196);
}
@media (max-width: 500px) {
    .proyectsToChange-container {
        width: 97%;
        margin: 0 auto;
    }

    .proyectsToChange-container .valuesProyectToActivate {
        margin-bottom: 0 !important;
    }

    .proyectsToChange-container .containerDataForm {
        width: 99%;
        margin: 0 auto;
    }

    .proyectsToChange-container img {
        max-width: 100%;
        width: 100%;
        margin-bottom: 20px;
    }

    .proyectsToChange-container .dataRef {
        padding-left: 0 !important;
        padding-bottom: 0 !important;
        margin-bottom: 0 !important;
        width: 100%;
        overflow-x: scroll;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/set-data-sale/set-data-sale/set-data-sale.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,2BAA2B;QAC3B,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.proyectsToChange-container {\n    width: 100%;\n    margin: 0;\n}\n\n.proyectsToChange-container > div {\n    background-color: #0e0f15;\n    border: 3px solid #f09502;\n}\n\n.proyectsToChange-container .noProyectsToChange {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n}\n\n.proyectsToChange-container img {\n    max-width: 30%;\n    height: auto;\n}\n\n.proyectsToChange-container .valuesProyectToActivate {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.proyectsToChange-container .valuesProyectToActivate > div {\n    padding-left: 15px;\n}\n\n.proyectsToChange-container .resaltar {\n    font-weight: bold;\n    color: #f09502;\n}\n\n.proyectsToChange-container .accordion-header buttom {\n    background-color: #0e0f15 !important;\n}\n\n.proyectsToChange-container form > div {\n    width: 100%;\n    display: flex;\n    align-items: stretch;\n    flex-wrap: wrap;\n}\n\n.proyectsToChange-container form label {\n    width: 100%;\n}\n\n.proyectsToChange-container form input {\n    display: inline-block;\n    width: 70%;\n    margin-right: 2%;\n}\n\n.proyectsToChange-container form button {\n    display: inline-block;\n    width: 27%;\n}\n\n.errorInput {\n    background-color: rgb(255, 196, 196);\n}\n@media (max-width: 500px) {\n    .proyectsToChange-container {\n        width: 97%;\n        margin: 0 auto;\n    }\n\n    .proyectsToChange-container .valuesProyectToActivate {\n        margin-bottom: 0 !important;\n    }\n\n    .proyectsToChange-container .containerDataForm {\n        width: 99%;\n        margin: 0 auto;\n    }\n\n    .proyectsToChange-container img {\n        max-width: 100%;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .proyectsToChange-container .dataRef {\n        padding-left: 0 !important;\n        padding-bottom: 0 !important;\n        margin-bottom: 0 !important;\n        width: 100%;\n        overflow-x: scroll;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
